// extracted by mini-css-extract-plugin
export default {"AgoTimestampLink":"Ago-module__AgoTimestampLink--cfwj_","timestampText":"Ago-module__timestampText--rtBsS"};